"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputBooleanCheckbox/index.js";
function InputBooleanCheckbox(_ref) {
  var className = _ref.className,
    field = _ref.field,
    object = _ref.object,
    id = _ref.id;
  function onChange(checked) {
    object[field] = checked;
  }
  var value = object[field];
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    className: className,
    onChange: onChange,
    defaultChecked: value,
    label: field,
    id: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 9
    }
  });
}
var _default = InputBooleanCheckbox;
exports["default"] = _default;